<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <TableLoading v-if="warehouse.publicId === '0'"/>
    <div v-else>
      <div class="row">
        <div class="col-xl-4">
          <div class="card">
            <div class="card-body">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <div class="d-flex">
                    <div class="flex-grow-1">
                      <div class="text-muted">
                        <h4 class="mb-3">{{warehouse.name}}</h4>
                        <p class="mb-3"><b>Description:</b> {{warehouse.description}}</p>
                        <p class="mb-2" v-if="warehouse.longi != null"><b>Location:</b> {{warehouse.longi}}, {{warehouse.lat}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="px-4 pb-4">
            <div class="row mb-4">
              <div class="col-3">
                <h2 class="card-title-desc">Warehouse Stock</h2>
              </div>
              <div class="col-4">
                <!--              <b-button variant="info" size="sm" class="py-2 text-white" type="submit">Download CSV</b-button>-->
              </div>
            </div>
            <stock-table :rows="warehouse.stock" :columns="columns" @updateStockInfo="updateStocks" @onSearch="searchFn"/>
            <!--          <b-pagination-->
            <!--              v-model="currentPage"-->
            <!--              :total-rows="warehouse"-->
            <!--              :per-page="perPage"-->
            <!--              size="lg"-->
            <!--              align="center"-->
            <!--              class="mt-3"-->
            <!--          />-->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import StockTable from "@/components/stock/stock-table";
import {SINGLE_WAREHOUSE} from "@/gql/stock";
import TableLoading from "@/components/TableLoading";

export default {
  page: {
    title: "Single Warehouse Stock",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {TableLoading, StockTable, PageHeader, Layout},
  name: "single-warehouse-stock",
  data() {
    return {
      title: "Single Warehouse Stock",
      items: [
        {
          text: "Stock",
          href: "/"
        },
        {
          text: "Single Warehouse Stock",
          active: true
        }
      ],
      warehouse: {
        publicId: '0',
        name: "",
        description: "",
        longi: "",
        lat: "",
        stock: []
      },
      currentPage: 1,
      perPage: 30,
      searchKeyword: "",
      columns: [
        {
          field: 'productId',
          label: 'Product Name'
        },
        {
          field: 'productCode',
          label: 'Product Code'
        },
        {
          field: 'quantityCase',
          label: 'QTY (C/S)'
        },
        {
          field: 'quantityBall',
          label: 'QTY (Ball)'
        },
        {
          field: 'quantityPiece',
          label: 'QTY (Pieces)'
        },
        {
          field: 'quantity',
          label: 'Order Unit Qty'
        },
        {
          field: 'actions',
          label: 'Actions'
        },
      ],
    }
  },
  apollo: {
    warehouse: {
      query: SINGLE_WAREHOUSE,
      variables() {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  methods: {
    updateStocks(){
      this.$apollo.queries.warehouse.refetch()
    },
    searchFn(data){
      this.searchKeyword = data
    },
  }
}
</script>

<style scoped>

</style>
